export const SET_USERINFO = 'USERINFO::SET_USERINFO';
export const LOGOUT = 'USERINFO::LOGOUT';

export type State = {
    token: string;
    role: string;
    userId: number;
    remember: boolean;
}

export type Action = {
    type: typeof SET_USERINFO | typeof LOGOUT;
    payload?: State
}
